import axios from 'axios';
import { messageNotification } from '@shared/services/gf.notification.service';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import store from '@/store/index';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member

export default {
  createProject(data) {
    return axios
      .post(`/api/admin/project/create`, data, {
        formName: FORM_NAME_ENUMS.PROJECT_CREATE_FORM
      })
      .then((res) => res?.data)
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  createMirror(data) {
    return axios
      .post(`/api/admin/project/create-mirror`, data, {
        formName: FORM_NAME_ENUMS.MIRROR_CREATE_FORM
      })
      .then((res) => res?.data)
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  importBase(data) {
    return axios
      .post(`/api/admin/project/import-base`, data, {
        formName: FORM_NAME_ENUMS.IMPORT_BASE_FORM
      })
      .then((res) => res?.data)
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  importProject(data) {
    return axios
      .post('/api/admin/project/import', data, {
        formName: FORM_NAME_ENUMS.PROJECT_IMPORT_FORM,
        headers: 'multipart/form-data'
      })
      .then((res) => res?.data)
      .catch((err) => {
        if (err.response.data.status === 400) {
          smallNotification('danger', { title: err.response.data.detail });
        } else {
          smallNotification('danger', { title: 'Произошла ошибка' });
        }
        throw err;
      });
  },
  // createFork(userAlias, projectAlias, data) {
  //   return axios
  //     .post(`/api/project/${userAlias}/${projectAlias}/fork`, data, {
  //       formName: FORM_NAME_ENUMS.FORK_CREATE_FORM
  //     })
  //     .then((res) => res?.data)
  //     .catch((err) => {
  //       messageNotification('danger', {
  //         message: 'Проверьте корректность заполнения формы!',
  //         hasTimeline: false
  //       });
  //       throw err;
  //     });
  // },
  getGitIgnoreTemplates() {
    return axios.get(`/api/admin/project/create/gitignores`).then((res) => {
      store.dispatch('setAdminGitIgnoreTemplates', res.data);
      return res.data;
    });
  },
  getAllowedOwners(params) {
    return axios
      .get(`/api/admin/project/create/allowed-owners`, { params })
      .then((res) => res.data);
  }
};
